import { SectionHeading } from "../home/CtaButtons";
import { MediaImage } from "../MediaImage";
import { useSiteMedia } from "../../lib/siteMedia";
import { TextBody } from "./TextBody";

export const InfoSection = ({ id, eyebrow, title, lead, tone = "white", children, testid }) => (
  <section id={id} aria-labelledby={`${id}-title`} className={`section scroll-mt-28 ${tone === "slate" ? "border-y border-slate-200 bg-slate-50" : ""}`} data-testid={testid || `info-section-${id}`}>
    <div className="container-tight">
      <SectionHeading id={`${id}-title`} eyebrow={eyebrow} title={title} lead={lead} />
      <div className="mt-10">{children}</div>
    </div>
  </section>
);

export const FactorGrid = ({ items, testid = "factor-grid" }) => (
  <ul className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid={testid}>
    {items.map(({ icon: Icon, title, text }) => (
      <li key={title} className="card card-hover p-6">
        <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-maas-soft text-maas"><Icon className="h-5 w-5" aria-hidden="true" /></span>
        <h3 className="mt-4 text-[17px] font-semibold text-ink">{title}</h3>
        <p className="mt-2 text-[14.5px] leading-relaxed text-slate-600">{text}</p>
      </li>
    ))}
  </ul>
);

// Tekst naast een illustratie; het beeld draagt altijd het label "Illustratie".
export const IllustratedSplit = ({ mediaKey, title, text, reverse = false, testid }) => {
  const media = useSiteMedia();
  return (
    <div className="grid items-center gap-8 lg:grid-cols-12 lg:gap-12" data-testid={testid}>
      <div className={`lg:col-span-6 ${reverse ? "lg:order-2" : ""}`}>
        {title && <h3 className="text-[22px] font-bold leading-snug text-ink">{title}</h3>}
        <TextBody text={text} className="mt-4" />
      </div>
      <div className="lg:col-span-6">
        <div className="frame"><MediaImage media={media(mediaKey)} sizes="(min-width: 1024px) 600px, calc(100vw - 32px)" className="aspect-[4/3] rounded-[14px]" testId={`${testid}-image`} /></div>
      </div>
    </div>
  );
};

export const ExampleCards = ({ items }) => (
  <ul className="grid gap-5 lg:grid-cols-3" data-testid="example-cards">
    {items.map((ex) => (
      <li key={ex.title} className="card flex flex-col p-6">
        <p className="text-[12px] font-semibold uppercase tracking-[0.14em] text-gold">{ex.tag}</p>
        <h3 className="mt-2 text-[18px] font-semibold leading-snug text-ink">{ex.title}</h3>
        <p className="mt-2 text-[14.5px] leading-relaxed text-slate-600">{ex.text}</p>
        <p className="mt-4 text-[13px] font-semibold uppercase tracking-wide text-slate-500">Prijsbepalend</p>
        <TextBody text={ex.factors.map((f) => `- ${f}`).join("\n")} className="mt-2" />
      </li>
    ))}
  </ul>
);
